import { CATEGORY_API_PATH } from 'constants/api';
import { CategoryInterface } from 'type/categoryType';
import { ApiService } from './apiService';

class CategoryApiService extends ApiService<CategoryInterface> {}

export const categoryApiService = new CategoryApiService(CATEGORY_API_PATH);
